import apiClient from './AuthService';

const ADMIN_PREFIX = '/admin/subscriptions';
const ARCHITECTS_PREFIX = '/admin/architects';
const ME_PREFIX = '/me';

export interface Subscription {
    subscriptionId: string;
    name: string;
    monthlyPriceCents: number;
    annualPriceCents: number;
    extraProjectPriceCents: number;
    projectsPerYearLimit: number;
    createdAt: string;
    updatedAt: string;
}

export interface SubscriptionPayload {
    name: string;
    monthlyPriceCents: number;
    annualPriceCents: number;
    extraProjectPriceCents: number;
    projectsPerYearLimit: number;
}

export interface QuotaSnapshot {
    plan_name: string | null;
    limit: number;
    used: number;
    remaining: number;
    assigned_at: string | null;
    expires_at: string | null;
}

const toBackend = (p: SubscriptionPayload) => ({
    name: p.name,
    monthly_price_cents: p.monthlyPriceCents,
    annual_price_cents: p.annualPriceCents,
    extra_project_price_cents: p.extraProjectPriceCents,
    projects_per_year_limit: p.projectsPerYearLimit,
});

export const getAllSubscriptions = async (): Promise<Subscription[]> => {
    const response = await apiClient.get<{ data: Subscription[] }>(ADMIN_PREFIX);
    return response.data.data;
};

export const createSubscription = async (payload: SubscriptionPayload): Promise<any> => {
    const response = await apiClient.post(ADMIN_PREFIX, toBackend(payload));
    return response.data;
};

export const updateSubscription = async (id: string, payload: SubscriptionPayload): Promise<any> => {
    const response = await apiClient.put(`${ADMIN_PREFIX}/${id}`, toBackend(payload));
    return response.data;
};

export const deleteSubscription = async (id: string): Promise<any> => {
    const response = await apiClient.delete(`${ADMIN_PREFIX}/${id}`);
    return response.data;
};

export const getArchitectSubscription = async (architectId: string): Promise<QuotaSnapshot> => {
    const response = await apiClient.get<{ data: QuotaSnapshot }>(`${ARCHITECTS_PREFIX}/${architectId}/subscription`);
    return response.data.data;
};

export const assignArchitectSubscription = async (architectId: string, subscriptionId: string): Promise<any> => {
    const response = await apiClient.post(`${ARCHITECTS_PREFIX}/${architectId}/subscription`, {
        subscription_id: subscriptionId,
    });
    return response.data;
};

export const cancelArchitectSubscription = async (architectId: string): Promise<any> => {
    const response = await apiClient.delete(`${ARCHITECTS_PREFIX}/${architectId}/subscription`);
    return response.data;
};

export const getMySubscription = async (): Promise<QuotaSnapshot> => {
    const response = await apiClient.get<QuotaSnapshot>(`${ME_PREFIX}/subscription`);
    return response.data;
};
